export default __webpack_public_path__ + "static/media/Process.8edfd1fc.jpeg";